/** * 核酸报告列表 * */
<template>
  <div>
    <!-- <div class="date-btn">
      <van-icon name="calender-o" />
      <span @click="showStartPicker = true">{{ getStartDate }}</span>
      至
      <span @click="showEndPicker = true">{{ getEndDate }}</span>
      <van-icon name="arrow-down" />
    </div> -->
    <!-- <div @click="showPickerCards = true" class="other-nat-record-card">
      <div>卡号查询</div>
      <div>{{ cardNo }} <van-icon name="arrow-down" /></div>
    </div> -->
    <ph-empty v-if="!inspectionList.length" />
    <div v-for="item in inspectionList" :key="item.year">
      <span class="list-item-year">
        {{ item.year }}
        <span>年</span>
      </span>
      <InspectionListMonthView
        v-for="subItem in item.list"
        :key="subItem.date"
        :date="subItem.date"
        :item-list="subItem.subItem"
        @routeToDetail="routeToDetail"
      />
    </div>
    <van-popup v-model="showPickerCards" position="bottom">
      <van-picker
        :columns="getCardList"
        @confirm="cardListConfirm"
        @cancel="showPickerCards = false"
        show-toolbar
      />
    </van-popup>
  </div>
</template>

<script>
// import InspectionListMonthView from "./components/InspectionListMonthView";
import InspectionListMonthView from "../../user/report/inspection/list/components/InspectionListMonthView.vue";
export default {
  components: {
    InspectionListMonthView
  },
  data() {
    return {
      inspectionList: [],
      showPickerCards: false,
      ftype: "1",
      qrtype: "1",
      cardList: [],
      cardNo: ""
    };
  },
  computed: {
    getCardList() {
      return this.cardList.map(item => {
        return item.cardNo;
      });
    },
    baseInfo() {
      if (this.cardList.length) {
        return this.cardList[this.currentCard];
      }
      return {};
    }
  },
  created() {
    // this.$http
    //   .post(this.$api.TEST_PATIENT_BYID, {
    //     phone: this.$route.query.phone,
    //     idCard: this.$route.query.idCard,
    //     name:this.$$route.query.name
    //   })
    //   .then(res => {
    //     this.cardList = res;
    //     this.cardNo = this.cardList[0].cardNo;
    //     this.getInspectionsList();
    //   });
    this.getInspectionsList();
  },
  methods: {
    getInspectionsList() {
      console.log("1111");
      this.$http
        .post(this.$api.TEST_REPORT_LIST, {
          phone: this.$route.query.phone,
          idCard: this.$route.query.idCard,
          name: this.$route.query.name,
          // cardNo: this.cardNo,
          hospitalId: "350802",
          mzorzy: "3"
        })
        .then(res => {
          const list = [];
          let result = {};
          // 按年分组
          res.forEach(item => {
            let itemKey = item.billingDate.substr(0, 4);
            if (result[itemKey]) {
              result[itemKey].push(item);
            } else {
              result[itemKey] = [item];
            }
          });
          // map转数组
          new Map(Object.entries(result)).forEach((value, key) => {
            list.push({
              year: parseInt(key),
              list: value.map(subItem => {
                return {
                  date: subItem.billingDate.substr(4),
                  subItem: subItem.list.map(inspectionItem => {
                    return {
                      id: inspectionItem.jydh,
                      title: inspectionItem.projectName,
                      inspectionType: inspectionItem.inspectionType
                    };
                  })
                };
              })
            });
          });
          // 按日期排序
          list.sort((a, b) => {
            return a.year < b.year ? 1 : -1;
          });
          this.inspectionList = list;
        });
    },
    cardListConfirm(_, id) {
      this.currentCard = id;
      this.cardNo = this.cardList[id].cardNo;
      this.showPickerCards = false;
      this.getInspectionsList();
    },
    routeToDetail(item, list, date) {
      this.$router.push({
        name: "nucleic-record-detail",
        query: {
          currentItem: item,
          list,
          date,
          cardNo: this.cardNo
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.list-item-year {
  margin-left: 0.5rem;
  color: #3f3f3f margin-left 1.5rem;
  font-size: 1.5rem;

  span {
    font-size: 1rem;
  }
}
.other-nat-record-card {
  display: flex;
  align-content: center;
  justify-content: space-between;
  margin: 0.5rem;
  font-size: 0.9rem;
  border: 2px solid @primary-blue;

  &-title {
    border-right: 2px solid @primary-blue;
  }
  div {
    padding: 0.5rem;
  }
  i {
    margin-left: 0.5rem;
    vertical-align: middle;
  }
}
.date-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0.5rem;
  padding: 0.5rem;
  font-size: 0.94rem;
  border: solid 1px #aaa;
  border-radius: 4px;
}
</style>
